<template>
  <UForm ref="formRef" :state="form" :schema="schema">
    <UFormField v-if="inspectionTemplateId"
      class="mb-3 w-full grid grid-cols-1 sm:grid-cols-[180px_1fr] md:grid-cols-[180px_1fr] gap-0 md:gap-4 items-start"
      :label="$t('inspection_templates.object_name')" 
      name="inspectionTemplateId">
      <p class="w-full" style="margin-top:-4px !important">{{ inspectionTemplateName }}</p>
    </UFormField>
    <UFormField v-else
      class="w-full mb-3 grid grid-cols-1 md:grid-cols-[180px_1fr] gap-0 md:gap-4 items-start" 
      :label="$t('inspection_templates.object_name')" 
      name="inspectionTemplateId"
    >
      <UButtonGroup class="inspectionBatchButtonGroup w-full gap-0 ">
        <input
          v-model="treeB.filter.value"
          :ref="treeB.inputRef"
          style="font-size:14px !important;"
          type="text"
          :placeholder="$t('common.form_control.select_select')"
          @focus="treeB.toggleSearchTree"
          :class="(treeB.filter.value ? ' rounded-r-none !rounded-r-none ' :'' ) +
            ' w-full three-ac-form-control text-xs bg-white rounded-md focus:outline-none focus:ring-0 focus:ring-blue-500 focus:border-blue-500 placeholder:text-gray-900' "
      /><ChevronDown id="iconDataEntryChevron" :class="chevronClassB" style="color:gray" />
        <UButton
          v-if="treeB.filter.value"
          icon="i-lucide-circle-x"
          variant="subtle"
          id="btnDataEntrySearchCleaner"
          class="cursor-pointer" color="neutral" 
          @click="treeB.filter.value = '';treeB.selectedNodes.value = []"
          :title="$t('common.tooltip.clear')"
          style="color:red;margin-top:0px !important;height:32px !important"
        />
      </UButtonGroup>
      <div v-if="treeB.showTree.value">
        <div
          :ref="treeB.treeRef"
          class="absolute right-0 mt-1 w-full md:min-w-[250px] md:max-w-[266px] bg-white  rounded shadow z-50"
          >
          <Tree id="" class="search-tree-3a less-space max-h-[190px]" style="width: 100%;" 
            :value="treeB.filteredNodesValue.value" 
            v-model:selection-keys="treeB.selectedNodes.value"
            v-model:expanded-keys="treeB.expandedKeys"
            selectionMode="single" />
        </div>
      </div>
    </UFormField>
    <div class="mb-2 mt-2 pb-0.5 block sm:block md:block lg:block">
      <hr class="mb-2 border-gray-200 " />
    </div>
    <UFormField
        class="mb-3 grid grid-cols-1 sm:grid-cols-[180px_1fr] md:grid-cols-[180px_1fr] gap-0 md:gap-4 items-start"
        :label="$t('inspection_rex3.inspection_date')"
        name="fechaSalida"
      >
      <div v-show="isReadOnly" class="mt-0 md:-mt-1">
        <span class="p-2 text-gray-700">
          {{ '--' }}
        </span>
      </div>
      <div v-show="!isReadOnly" class="mt-0 sm:-mt-2.5 md:-mt-2.5">
        <UButtonGroup class="w-full">
          <UPopover>
            <UButton color="neutral" style="background-color:white"
              class="cursor-pointer w-full" variant="subtle" icon="i-lucide-calendar">
              {{ form.fechaSalida ? fechaSalidaDate : $t('common.form_control.datepicker_select') }} 
            </UButton>
            <template #content>
              <UCalendar v-model="form.fechaSalida" class="p-2" :locale="calendarLocale"/>
            </template>
          </UPopover>
          <UButton
            v-if="form.fechaSalida"
            icon="i-lucide-circle-x"
            variant="subtle"
            class="cursor-pointer" color="neutral" 
            @click="clearFecha()"
            title="Limpiar fecha"
            style="color:red"
          />
        </UButtonGroup>
      </div>
    </UFormField>
    <UFormField
        class="mb-3 grid grid-cols-1 sm:grid-cols-[180px_62px] md:grid-cols-[180px_62px] gap-0 md:gap-4 items-start"
        :label="$t('inspection_rex3.inspection_hour')"
        name="horaSalida"
      >
      <div v-show="isReadOnly" class="mt-0 md:-mt-1">
        <span class="p-2 text-gray-700">
          {{ '--' }}
        </span>
      </div>
      <div v-show="!isReadOnly" class="mt-0 sm:-mt-2.5 md:-mt-2.5 max-w-[60px] ">
        <DatePicker id="datepicker-timeonly" v-model="form.horaSalida" class=" h-[32px]"  style="font-size:0.5rem !important"
          timeOnly fluid :manualInput="false" @click.stop showTime :modal="false" appendTo="self" :pt="{
            panel: { class: 'z-[49]' }
          }"/>
      </div>
    </UFormField>
    <div class="mb-2 mt-2 pb-0.5 block sm:block md:block lg:block">
      <hr class="mb-2 border-gray-200 " />
    </div>
    <UFormField v-if="form.idProduct"
      :label="$t('products.object_name')" 
      name="idProduct"
      class="mb-3 grid grid-cols-1 md:grid-cols-[180px_1fr] xl:grid-cols-[180px_1fr] gap-0 md:gap-4 items-start"
    >
      <div v-show="isReadOnly" class="mt-0 md:-mt-1">
        <USkeleton v-if="onReadOnlyProductName == ''" class="h-4 w-[180px]"/>
        <span v-else class="py-2 text-gray-700">
          {{ onReadOnlyProductName }}
        </span>
      </div>
      <div v-show="!isReadOnly" class="mt-0 md:-mt-2.5">
        
        <div v-if="loadingProducts && !initialized" class="py-1.5"><USkeleton class="h-4 w-[180px]"/></div>
        <USelectMenu v-else
          value-key="value" 
          :items="productOptions"
          v-model='(form.idProduct as string)'
          option-attribute="label"
          value-attribute="value"
          placeholder="- Seleccionar -"
          class="w-full md:max-w-[270px]"
          color="neutral"
          :search-input="{
            placeholder: $t('common.form_control.uselectmenu_placeholder'),
            icon: 'i-lucide-search'
          }"
        />
      </div>
    </UFormField>
    <div class="mb-2 mt-2 pb-0.5 block sm:block md:block lg:block">
      <hr class="mb-0 mt-4 border-gray-200 " />
    </div>
    <UFormField 
      class="text-xs mb-3 grid grid-cols-1  gap-0 md:gap-4 items-start" 
      :label="$t('common.object.notes')" 
      name="notes"
    >
      <div v-show="isReadOnly" class="mt-0 md:-mt-1">
        <span class="p-2 text-gray-700">{{ form.notes }}</span>
      </div>
      <div v-show="!isReadOnly" class="text-xs mt-0 md:-mt-2.5">
        <UInput v-model="form.notes" class="text-xs w-full" color="neutral" 
          :ui="{base: 'text-xs'}"
          />
      </div>
    </UFormField>
  </UForm>
</template>

<script lang="ts" setup>
const { t: $t } = useI18n()

  /* :ui="{
    base: 'text-xs'
  }" */
  import { ref } from 'vue'
  import { z } from 'zod' 
  import type { Material } from '~/types/material';
  import type { Supplier } from '~/types/supplier'; 
  import type { InspectionRex3 } from '~/types/data-entry/inspectionRex3';
  import Tree from 'primevue/tree'
  import { CalendarDate, DateFormatter, getLocalTimeZone } from '@internationalized/date'
  import DatePicker from 'primevue/datepicker';
  import { format } from 'date-fns'
  import { X, Search, Filter, ChevronDown, Tag, Download} from 'lucide-vue-next'

  const toast = useToast()
  const formRef = ref()
  const { t } = useI18n()
  const { locale } = useI18n() // reactive locale
  const { combineFechaHora, selectedTimezone } = useTimezoneDate()

  const initialized = ref(false);
  const onReadOnlyProductName = ref('');

  const shiftOptions = ref<{ label: string; value: string }[]>([{ label: $t('common.form_control.select_select'), value: "-1" }])
  const productOptions = ref<{ label: string; value: string }[]>([{ label: $t('common.form_control.select_select'), value: "-1" }])
  const partOptions = ref<{ label: string; value: string }[]>([{ label: $t('common.form_control.select_select'), value: "-1" }])

  const form = reactive({
    fechaSalida: shallowRef<CalendarDate | null>(null),
    horaSalida: null as Date | null,
    //inspectionTemplateId: "" as string,
    idProduct: String('-1'),
    notes: "" as string,
  })

  const horaSalidaString = ref("");
  watch(() => form.horaSalida, (value) => {
    if (!value) return;
    horaSalidaString.value = value.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  });
  const fechaSalidaDate = computed(() => {
    if (!form.fechaSalida || typeof form.fechaSalida.toDate !== "function") return null;
    return df.value.format(form.fechaSalida.toDate(getLocalTimeZone()));
  });

  // DATE PICKER LOGIC
  const modelValue = shallowRef<CalendarDate | null>(null)
  const df = computed(() => {
    return new DateFormatter(locale.value, {
      dateStyle: 'long'
    })
  })
  const today = new Date()
  function clearFecha(): null {
    form.fechaSalida = null;
    return null;
  }
  const calendarLocale = computed(() => {
    return locale.value
  })

  const formatDateForBackend = (date: CalendarDate | null): string | null => {
    if (!date) return null
    return date.toDate(getLocalTimeZone()).toISOString()
  }
  // END OF DATE PICKER LOGIC
  
  // validación con zod
  const schema = z.object({ 
    fechaSalida: z.any()
      .refine(v => v && typeof v?.toDate === "function", {
        message: $t('inspection_rex3.message.create.select_date')  
      }),
    horaSalida: z
      .date({
        required_error: $t('inspection_rex3.message.create.select_time'),
        invalid_type_error: $t('inspection_rex3.message.create.select_time')
      })
      .nullable()
      .refine(val => val !== null, {
        message: $t('inspection_rex3.message.create.select_time')
      }),
    idProduct: z.string({
        required_error: $t('common.message.form_validation.required'),
        invalid_type_error: $t('common.message.form_validation.must_select_option') 
      })
      .min(1, $t('common.message.form_validation.required'))
      .refine((val) => val !== "-1", { message: $t('common.message.form_validation.must_select_option')  })
  })

  const { items: productDataResponse, loading: loadingProducts, load: loadProducts
        } = useCatalogoPlano<Rex3Spec>('catalogo-rex3-specs', `/Rex3Specs/get-all`)
  
  const { getCatalog } = useCatalogs()

  //////////////////////////////////////
  
  const allowHidden = true;
  const treeB  = useDataEntryTree(allowHidden,locale,'iqa-data-entry-tree-cache-rex3');
  const inspectionDateLabel = ref("");
  onMounted(async () => {
    swal_loading();
    await Promise.all([
      loadProducts(),
    ]);
    cargarCatalogos();
    swal_close();
    const now = new Date()
    form.fechaSalida = new CalendarDate(
      now.getFullYear(),
      now.getMonth() + 1, // ⚠️ meses empiezan en 1
      now.getDate()
    ) 
    form.horaSalida = now
    document.addEventListener('mousedown', treeB.handleClickOutside)
    treeB.expandTopNode();
    treeB.showTree.value = true;
    initialized.value = true;
  });
  
  onBeforeUnmount(() => {
    document.removeEventListener('mousedown', treeB.handleClickOutside);
  })
  
  const chevronClassB = computed(() => {
    const selectedKeys = Object.keys(treeB.selectedNodes.value);
    const base = 'pointer-events-none absolute top-1/2 -translate-y-1/2 w-3 h-3 text-gray-400'
    const pos = treeB.filter.value && selectedKeys.length > 0 ? 'right-9' : 'right-3'
    return `${base} ${pos}`
  })

  const props = defineProps<{
    id: string,
    inspectionTemplateId: number | null,
    inspectionTemplateName?: string | null,
    isUpdate: boolean,
    isReadOnly: boolean
  }>();

  const materialOptions = ref<{ label: string; value: string }[]>([{ label: $t('common.form_control.select_select'), value: "-1" }])
  const supplierOptions = ref<{ label: string; value: string }[]>([{ label: $t('common.form_control.select_select'), value: "-1" }])

  const { id, inspectionTemplateId, inspectionTemplateName, isUpdate } = props
  const { isReadOnly } = toRefs(props)

  const emit = defineEmits<{
    (event: 'emit-from-component', id: string): void;
    (event: 'close-from-component'): void;
    (e: 'child-ready'): void // ✅ Add this line
  }>();

  const handleEmission = () => {
    emit('emit-from-component', props.id);
  }

  const handleClose = () => {
    emit('close-from-component');
  }

  
  async function submitForm(): Promise<{success: boolean, message: string | null, data: {}}>
  {
    
    const inspectionTemplateId = ref(undefined as number | undefined);
    if(props.inspectionTemplateId) {
      inspectionTemplateId.value = props.inspectionTemplateId;
    }
    else
    {
      const keys = Object.keys(treeB.selectedNodes.value)
      //if (!keys.length) return false

      const selectedKey = keys[0]
      const node = treeB.findNodeByKey(treeB.nodes.value, selectedKey)

      if( node?.type == undefined )
      {
        toast.add({
          title: $t('inspections.template_selection_for_form_loading'),
          description: $t('common.message.form_validation.must_select_option'),
          color: 'error',
          icon: 'i-lucide-triangle-alert'
        });
        return Promise.resolve({success: false, message: null, data: {}});
      }
      else if( node?.nodeType === 'TYPE' )
      {
        toast.add({
          title: $t('inspections.template_selection_for_form_loading'),
          description: $t('inspections.template_selection_error'),
          color: 'error',
          icon: 'i-lucide-triangle-alert'
        });
        return Promise.resolve({success: false, message: null, data: {}});
      }
      if (!keys.length) 
        return Promise.resolve({success: false, message: null, data: {}});
      formRef.value?.submit();

      inspectionTemplateId.value = ref(node?.id);
    }//.fin de validación de selección de template

    const result = schema.safeParse(form);
    
    if (!result.success) {
      const firstError = Object.values(result.error.flatten().fieldErrors)[0]?.[0]
      toast.add({
        title: $t('common.message.form_validation.default_error_message'),
        description: firstError,
        color: 'error',
        icon: 'i-lucide-triangle-alert'
      })
      return Promise.resolve({success: false, message: null, data: {}});
    }
    if(form.fechaSalida == null || form.horaSalida == null)
      return Promise.resolve({success: false, message: $t('common.message.form_validation.default_error_message'), data: {}});
    const fechaSalidaISO = combineFechaHora(form.fechaSalida, form.horaSalida);
    
    //return false;
    const json_request = {
      ...(isUpdate && { id: id }),
      inspectionTemplateId: inspectionTemplateId.value,
      inspectorUserId: JSON.parse(localStorage.getItem("iqa-auth")|| "[{}]").user.id,
      productId: form.idProduct,
      rex3SpecId: 4, //TODO: frontend no debe enviar este valor
      inspectionDate: fechaSalidaISO,
      overallStatus: 'P',
      notes: form.notes,
      //isActive: true,
    };

    try {
      swal_loading();
      let data, error;
      
      if (!isUpdate) {
        ({ data, error } = await useApiFetchObject<InspectionBatch>(
          '/inspection-rex3/CreateHeader',
          {
            method: 'POST',
            body: json_request
          }
        ));
      } else {
        ({ data, error } = await useApiFetchObject<{ success: boolean; message: string, data: InspectionBatch | null }>(
          `/inspection-rex3/update/${id}`,
          {
            method: 'PUT',
            body: json_request
          }
        ));
      }
      if (error.value) {
        console.error("Error submitting:", error.value);
        // Mostrar alerta o toast aquí
      } else {
        
        emit('close-from-component');
        // Emit otro evento si deseas refrescar lista
      }

      if (error.value) { //Error de servidor, mostrar swal
        await swal_oops( data?.value?.message || $t('common.message.create.error') );
        //return new Promise((resolve) => {resolve(true);});
        return Promise.resolve({success: false, message: data?.value?.message || $t('common.message.create.error'), data: {}});
      }

      if (!data?.value?.success) { //Error de proceso, mostrar toast
        toast.add({
          title: $t('common.message.create.error'),
          description: data?.value?.message,
          color: 'error',
          icon: 'i-lucide-triangle-alert'
        });
        return Promise.resolve({success: false, message: data?.value?.message as string, data: {}});
      }
      
      return Promise.resolve({success: true, message: data?.value?.message as string, data: data?.value?.data});
      

    } catch (err: any) {
      toast.add({
        title: $t('common.message.form_validation.unexpected_error'),
        description: err.message,
        color: 'error',
        icon: 'i-lucide-triangle-alert'
      });
      return Promise.resolve({success: false, message: err.message, data: {}});
    }
  }

  defineExpose({ 
    submitForm,
  })

  function cargarCatalogos(){
    productOptions.value = [
      { label: $t('common.form_control.select_select'), value: "-1" },
      ...(productDataResponse.value
        .map((product) => ({
          label: product.productName,
          value: String(product.productId)
        })) ?? [])
    ];
  }

</script>

<style>
@media (max-width: 767px){
  .inspectionBatchButtonGroup{
    top:0px;
  }
  .inspectionBatchNavSearch{
    max-width:310px !important;
  }
}
@media (min-width: 768px){
  .inspectionBatchButtonGroup{
    top:-9px !important;
  }
  .inspectionBatchNavSearch{
    max-width:268px !important;
    /*font-size: 14px !important;*/
  }
}
.p-inputtext{
  font-size:14px !important;
  font-weight: 500;
}

</style>